export default __webpack_public_path__ + "static/media/H2.jpg";